


























































import { Component, Vue, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex"
import ReportMarginVue from "./ReportMargin.vue"

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "report-margin": ReportMarginVue
    }
})
export default class SubsidiaryAllPrint extends Vue {
    @Prop({ type: Object })
    dataList!: any;

    @Prop({ type: Array })
    period!: Date[];

    @Prop({ type: Boolean, default: false })
    noSelect!: boolean;

    @Prop({ type: Number })
    sheetIndex!: number;

    @Prop({ type: String })
	fontSize!: string;


    get endPeriod() {
        let start = this.$utils.simpleDateFormat(this.period[0], "m"),
            end = this.$utils.simpleDateFormat(this.period[1], "m");
        if (start === end) return end.substring(0, 4) + "年" + end.substring(4) + "月";
        else return `${start}至${end}`;
    }

}
